import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { NAVBAR_THEME } from 'lib/navbar';
import BTE from 'lib/BTE';
import { setTheme as setThemeAction } from 'redux/modules/navbar';
import { package as packagePropType } from 'lib/CustomPropTypes';

import WaffleList from '../WaffleList';
import WaffleHeader from '../WaffleHeader';

import styles from '../styles.module.scss';

const mapActionsToProps = (dispatch) => ({
  setTheme: (theme) => dispatch(setThemeAction(theme)),
});

const mapStateToProps = ({ shared, navbar }) => ({
  vertical: shared.vertical,
  navTheme: navbar.theme,
});

@connect(mapStateToProps, mapActionsToProps)
class Waffle extends React.Component {
  height = null;

  static propTypes = {
    content: packagePropType.isRequired,
    vertical: PropTypes.string,
    setTheme: PropTypes.func.isRequired,
    navTheme: PropTypes.string.isRequired,
    pkgClassName: PropTypes.string,
    adsDisabled: PropTypes.bool,
  }

  static defaultProps = {
    vertical: 'today',
    pkgClassName: 'pkg waffle',
    adsDisabled: false,
  }

  componentDidMount() {
    BTE.on('scroll', this.handleScroll, 'throttle');
    BTE.on('resize', this.handleResize);
    this.setHeight();
  }

  componentWillUnmount() {
    BTE.remove('scroll', this.handleScroll);
    BTE.remove('resize', this.handleResize);
  }

  setHeight() {
    const box = this.container.getBoundingClientRect();
    this.height = box.top + window.pageYOffset;
  }

  handleResize = () => {
    this.setHeight();
  }

  handleScroll = (depth) => {
    const { navTheme, setTheme } = this.props;
    // need to set height every scroll because if a user refreshes
    // in the middle of the page the height will only
    // be set once, so in that case it is forever using the LIGHT THEME.
    this.setHeight();
    if (depth > this.height && navTheme !== NAVBAR_THEME.LIGHT) {
      setTheme(NAVBAR_THEME.LIGHT);
      return;
    }

    if (depth <= this.height && navTheme !== NAVBAR_THEME.TRANSPARENT) {
      setTheme(NAVBAR_THEME.TRANSPARENT);
    }
  }

  render() {
    const {
      content = {},
      adsDisabled,
      pkgClassName,
      vertical,
    } = this.props;
    const { metadata = {}, packageIndex, id } = content || {};
    const {
      title,
      description,
      shortDescription,
      attribution,
      backgroundImageUrl,
      logoUrl,
    } = metadata || {};

    const waffleCards = (content.items || []).filter((item) => item);
    return (
      <div
        className={classNames(pkgClassName, styles.waffle)}
        ref={(e) => { this.container = e; }}
        data-packageid={id}
      >
        <WaffleHeader
          backgroundImageUrl={backgroundImageUrl}
          title={title}
          logoUrl={logoUrl}
          description={description}
          shortDescription={shortDescription}
          attribution={attribution}
          cardCount={waffleCards.length}
          animateBackground
          packageIndex={packageIndex}
          content={content}
        />
        <WaffleList
          cards={waffleCards}
          vertical={vertical}
          adsDisabled={adsDisabled}
          metadata={content.metadata}
        />
      </div>
    );
  }
}

export default Waffle;
